import * as THREE from 'three';

export class CollisionSystem {
  private colliders: THREE.Object3D[];
  private raycaster: THREE.Raycaster;
  
  constructor() {
    this.colliders = [];
    this.raycaster = new THREE.Raycaster();
  }
  
  addCollider(object: THREE.Object3D): void {
    this.colliders.push(object);
  }
  
  removeCollider(object: THREE.Object3D): void {
    const index = this.colliders.indexOf(object);
    if (index !== -1) {
      this.colliders.splice(index, 1);
    }
  }
  
  checkCollision(position: THREE.Vector3, direction: THREE.Vector3, distance: number = 0.5): boolean {
    this.raycaster.set(position, direction.normalize());
    const intersects = this.raycaster.intersectObjects(this.colliders, true);
    
    return intersects.length > 0 && intersects[0].distance < distance;
  }
  
  getColliders(): THREE.Object3D[] {
    return this.colliders;
  }
  
  // Helper method to check if a character can move to a new position
  canMoveTo(currentPosition: THREE.Vector3, targetPosition: THREE.Vector3, characterHeight: number = 1.8): boolean {
    // Direction vector from current to target position
    const direction = new THREE.Vector3().subVectors(targetPosition, currentPosition).normalize();
    
    // Distance to check
    const distance = currentPosition.distanceTo(targetPosition);
    
    // Check collision at character's feet
    const feetPosition = new THREE.Vector3(currentPosition.x, currentPosition.y, currentPosition.z);
    if (this.checkCollision(feetPosition, direction, distance)) {
      return false;
    }
    
    // Check collision at character's middle
    const middlePosition = new THREE.Vector3(currentPosition.x, currentPosition.y + characterHeight * 0.5, currentPosition.z);
    if (this.checkCollision(middlePosition, direction, distance)) {
      return false;
    }
    
    // Check collision at character's head
    const headPosition = new THREE.Vector3(currentPosition.x, currentPosition.y + characterHeight, currentPosition.z);
    if (this.checkCollision(headPosition, direction, distance)) {
      return false;
    }
    
    return true;
  }
  
  // Find the closest point on the ground below a position
  findGroundHeight(position: THREE.Vector3, maxDistance: number = 10): number {
    this.raycaster.set(
      new THREE.Vector3(position.x, position.y + maxDistance / 2, position.z),
      new THREE.Vector3(0, -1, 0)
    );
    
    const intersects = this.raycaster.intersectObjects(this.colliders, true);
    
    if (intersects.length > 0 && intersects[0].distance < maxDistance) {
      return intersects[0].point.y;
    }
    
    return position.y;
  }
} 